import { BioCardGrid } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { GetBiographyGridModel } from './C56BiographyGrid.service';
import { C56BiographyGridProps } from './C56BiographyGrid.types';

export const Default = (props?: C56BiographyGridProps): JSX.Element => {
  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return <BioCardGrid {...GetBiographyGridModel(props)} />;
};
